export const ID_PROPERTY = 'Id';
export const RESPONSE_PROPERTY = 'Response';
export const gcDatePerformedPropertyId = 'DatePerformed';
export const gcDateOfferedPropertyId = 'DateOffered';
export const gcDateRespondedPropertyId = 'DateResponded';
export const geneticCounselingElementId = 'GeneticCounseling';
export const gcPatientAgreementPropertyId = 'PatientAgreement';
export const gcTestResultsPropertyId = 'TestResults';
export const gcPatientAgreementNotInterestedOptionId = 'PatientNotInterested';
export const gcMyriadButtonTextOnSent = 'Myriad Data Sent';
export const gcMyriadButtonTextOnSendFailed = 'Retry Myriad Data';
export const gcDefaultSendToMyriadFailedMessage = 'Send data to Myriad Failed';
export const sendingToMyriadSpinnerMessage = 'Sending to Myriad';
export const gcPatientCompletedPropertyId = 'GenCounselComp';
export const gcPatientNotCompletedPropertyId = 'GenCounselNotComp'
export const gcPatientQualifiedPropertyId = 'GenCounselQual'
export const gcPatientNotQualifiedPropertyId = 'GenCounselNotQual';
export const sendToMyriadChangesFoundConfirmationMessage = 'You have not saved data which maybe lost. Do you want to save your changes before sending to Myriad?';
export const showTrfFormChangesFoundConfirmationMessage = 'You have not saved data which maybe lost. Do you want to save your changes before showing Test Requisition Form?';
export const sendToMyriadConfirmationButtonText = 'Send to Myriad';
export const showTrfFormConfirmationButtonText = 'Show';
export const ibisRiskModule = 'IBIS';
export const heraRiskModule = 'HERA';
export const nciRiskModule = 'NCI';
export const clausRiskModule = 'CLAUS';
export const brcaRiskModule = 'BRCA';
export const bcscRiskModule = 'BCSC';
export const brst3RiskModule = 'BRST3';
export const nccnRiskModule = 'NCCN';
export const defaultSendToMyriadBUttonText = 'Send to Myriad';
export const minimumNciRiskAge = 35;
export const defaultSortingColumn = 'DisplayOrder';
export const testResultBRCA1OptionId = 'TestResultBRCA1';
export const testResultBRCA2OptionId = 'TestResultBRCA2';
export const testResultAllId = 'TestResultALL';


// WEBPACK FOOTER //
// ./src/scripts/constants/risk-property-constants.js